import {
  BotStateEnum, BotVal, Defines, EntityVal, GK, type IBotAction
} from "../../defines";
import { CondMaker } from "../CondMaker";
import { DESIRE_RATIO_X_3 } from "./constants";
const MIN_X = -10 as const;
const MAX_X = 120 as const;
const ID = 'd^j' as const
/**
 * 矩形范围，检测成功将会按下D^A
 *
 * @export
 * @param {number} min_mp 至少需要多少mp
 * @param {number} [desire=0.0666] 欲望值
 * @param {number} [min_x=90] 最小距离 
 * @param {number} [max_x=120] 最大距离
 * @return {IBotAction}
 */
export function bot_uppercut_duj(
  min_mp: number,
  desire: number = DESIRE_RATIO_X_3,
  min_x: number = MIN_X,
  max_x: number = MAX_X
): IBotAction {
  const cond = new CondMaker<BotVal | EntityVal>().add(EntityVal.MP, '>=', min_mp)
  return {
    action_id: ID,
    desire: Defines.desire(desire),
    status: [BotStateEnum.Chasing],
    e_ray: [{ x: 1, z: 0, min_x, max_x }],
    expression: min_mp > 0 ? cond.done() : void 0,
    keys: [GK.d, GK.U, GK.j]
  };
}
bot_uppercut_duj.ID = ID
bot_uppercut_duj.MIN_X = MIN_X
bot_uppercut_duj.MAX_X = MAX_X